<template>
	<section class="page">
		<el-tabs v-model="activeName">
			<el-tab-pane label="管理员" name="list">
				<div class="content-box">
					<div class="operator">
						<div class="operator-col">
							<el-button size="mini" type="primary" @click="handleCreate()" v-loading="loadings.create">新建</el-button>
						</div>
					</div>
					<curd-table
						ref="listTable"
						:data-model="editorDataModel"
						:fields="tableFields"
						@doedit="handleEdit($event)"
					></curd-table>
				</div>
			</el-tab-pane>
			<el-tab-pane label="权限管理" name="permission"></el-tab-pane>
			<el-tab-pane label="操作日志" name="log"></el-tab-pane>
		</el-tabs>
		<editor
			:show.sync="editorVisible"
			:data-model-name="editorDataModel"
			:record-id="editorId"
			:fields="editorFields"
			@change="refreshTable('listTable')"
		></editor>
	</section>
</template>

<script>
import Editor from "@/components/Editor.vue";
import CurdTable from "@/components/CurdTable.vue";
import CurdPage from "@/mixins/CurdPage.js";

export default {
	mixins: [CurdPage],

	data() {
		return {
			loadings: {
				main: false,
			},
			activeName: "list",
			editorVisible: false,
			editorDataModel: "Adminuser",
			editorId: "",
			tableFields: [
				{
					name: "name",
					sortable: "custom",
				},
				{
					name: "phone",
				},
				{
					name: "is_superadmin",
				},
				{
					name: "is_saler",
				},
				{
					name: "has_leave",
				},
			],
			editorFields: [
				{
					name: "name",
					rules: ["required"],
					col: 6,
				},
				{
					name: "phone",
					rules: ["required"],
					col: 6,
				},
				{
					name: "password",
				},
				{
					name: "is_superadmin",
					col: 6,
				},
				{
					name: "has_leave",
					col: 6,
				},
				{
					name: "is_saler",
					col: 6,
				},
				{
					name: "privilege",
				},
			],
		};
	},
	computed: {},
	created() {},
	mounted() {},
	methods: {},
	watch: {},
	components: {
		Editor,
		CurdTable,
	},
};
</script>
<style lang="scss" scoped>
</style>
